export const findDeviceEventMarker = (
  markers: Record<string, uui.domain.ui.map.markers.DeviceEvents>,
  deviceEventId: string,
): uui.domain.ui.map.markers.DeviceEvents | undefined => {
  const marker = markers[deviceEventId]

  return marker
}
